export default "__VITE_ASSET__w3tySSUg__"